module.exports = __webpack_public_path__ + "img/icon-global.5ef3fd45.svg";